module.exports = [
	{
		"phase": "Launch",
		"priority_focus": "Reach new people.",
		"general_characteristics": "There’s a fresh purpose. Leaders have big dreams for the future. Hope prevails. People gravitate to new things.",
		"foundations": "Mission",
		"leadership": "Rely heavily on volunteer leaders",
		"ministry_strategy": "Weekend services are the focus.",
		"systems": "Few, if any, rules are implemented, and everyone is involved in almost every decision.",
		"staffing_structure": "Pastor and limited part-time staff",
		"finances": "New people don’t give, so finances are tight.",
		"key_next_steps": "Connect people to the mission and give ministry away."
	},
	{
		"phase": "Momentum Growth",
		"priority_focus": "Make space for new people—both physical space and ministry space.",
		"general_characteristics": "Entrepreneurial leaders gravitate to the team. People are unified. Creativity is valued. There’s an inviting culture—“come and see.” There’s lots of buzz!",
		"foundations": "Vision and values",
		"leadership": "Typically personality-driven",
		"ministry_strategy": "New programming added to help people connect and take their next steps.",
		"systems": "Leaders generally avoid establishing policies and systems.",
		"staffing_structure": "Ministry leaders added to start building teams",
		"finances": "New Christians don’t give! Numerical growth generates financial growth, but not at the same pace.",
		"key_next_steps": "Confirm the vision for the future and give leadership away."
	},
	{
		"phase": "Strategic Growth",
		"priority_focus": "Establish healthy strategy and systems.",
		"general_characteristics": "Outsiders would describe the team as high-performing. Leaders are still willing to change. The organization is more intentional.",
		"foundations": "Strategy and systems",
		"leadership": "Team-based leadership",
		"ministry_strategy": "The ministry strategy is focused around the growth engines.",
		"systems": "Growth necessitates establishing systems to keep everyone aligned.",
		"staffing_structure": "Administrative functions added, and staff are empowered to lead their ministries ",
		"finances": "Begin to build financial and giving systems to fund ministry and expand vision",
		"key_next_steps": "Clarify growth engines and and develop systems and structure around that strategy."
	},
	{
		"phase": "Sustained Health",
		"priority_focus": "Reproduce at all levels.",
		"general_characteristics": "The culture is collaborative. There’s a focused vision and strategy. The leaders will take calculated risks. A balance exists between refreshed vision and healthy systems.",
		"foundations": "Leadership development",
		"leadership": "Empowered leaders and teams",
		"ministry_strategy": "Ministry programming is reproduced through multiple locations or services.",
		"systems": "Healthy systems lead to empowered leaders and teams.",
		"staffing_structure": "Staffing and structure around growth engines including multisite and/or church planting",
		"finances": "Stewardship and generosity culture in place; investing in reproducing the church",
		"key_next_steps": "Become a reproducing church with an intentional strategy for leadership and spiritual development."
	},
	{
		"phase": "Maintenance",
		"priority_focus": "Keep people happy.",
		"general_characteristics": "Complexity reigns. There’s a shift toward an inward focus. Leaders control. Traditions are protected. Growth is still happening, though at slower pace. The vision stales.",
		"foundations": "Programs and events",
		"leadership": "Staff-driven with reduced volunteer empowerment",
		"ministry_strategy": "New ministry programming continues to expand and increase complexity with many events on the calendar.",
		"systems": "Systems and methods begin to supercede the mission and vision.",
		"staffing_structure": "Ministry silos and overstaffing while finances remain strong",
		"finances": "May be the most financially healthy season for the church; Growth slows, but finances may continue to increase",
		"key_next_steps": "Revisit the staff leadership and refresh the vision. Get refocused and remove complexity."
	},
	{
		"phase": "Preservation",
		"priority_focus": "Keep people from leaving.",
		"general_characteristics": "People desire to return to the ”good old days.” There’s an unwillingness to change. Leaders blame other churches for decline. Division takes root. People and money begin to leave.",
		"foundations": "Problems",
		"leadership": "Board-driven",
		"ministry_strategy": "Ministries jockey to preserve their turf even as the church declines.",
		"systems": "Culture becomes very bureaucratic. “What do the bylaws and constitution say?”",
		"staffing_structure": "Turf wars firmly established as staffing reductions offset financial decline",
		"finances": "Finances start to decline; Well-funded ministries (large reserves/endowments) can live here a long time",
		"key_next_steps": "Hire and empower new leadership to implement a fresh vision and a turnaround strategy."
	},
	{
		"phase": "Life Support",
		"priority_focus": "Reach new people with old methods.",
		"general_characteristics": "The church is bleeding both people and money. The last remnant of leaders is holding on. Endowments keep churches like this open for many years.",
		"foundations": "Crisis",
		"leadership": "Key family or key donor-driven",
		"ministry_strategy": "Everything becomes focused on keeping the doors open.",
		"systems": "Broken systems hasten ministry decline.",
		"staffing_structure": "Most paid positions eliminated with declining team morale",
		"finances": "Financial crisis usually is the primary trigger for a church to financial recognize the ministry is on life-support",
		"key_next_steps": "Close and relaunch or find another ministry to acquire the dying church."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/result/lifecycle_matrix.json
// module id = 431
// module chunks = 0